import { ReactElement, InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

function Input({ ...props }: InputProps): ReactElement {
  return (
    <div className="bg-black rounded-medium shadow-default py-1 pr-1 pl-2 h-5-px">
      <input
        className="bg-transparent caret-white outline-none w-full text-white"
        {...props}
      />
    </div>
  );
}

export default Input;
